var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZ17(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66.428 55.063",
    width: 66.428,
    height: 55.063,
    enableBackground: "new 0 0 66.428 55.063",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.503,15.048c-9.124,0-17.228,0-25.503,0C0,9.915,0,5.083,0,0c19.479,0,39.016,0,58.962,0 c0,4.56,0.412,9.235-0.202,13.771c-0.247,1.822-2.642,4.618-4.243,4.751c-4.511,0.374-5.806,4.379-8.597,6.516 c-4.296,3.288-7.824,7.583-11.648,11.478c-0.157,0.16-0.02,0.609-0.02,1.151c1.453-0.057,3.251,1.464,3.916-1.323 c0.052-0.22,0.945-0.336,1.448-0.337c8.879-0.02,17.759-0.014,26.813-0.014c0,5.09,0,9.922,0,15.254 c-3.266,0-6.61-0.071-9.949,0.037c-1.261,0.041-3.057-0.873-3.527,1.507c-0.056,0.285-1.735,0.346-2.662,0.348 c-8.903,0.025-17.808-0.028-26.71,0.078c-0.96,0.011-1.895,0.926-2.871,1.352c-0.544,0.237-1.148,0.465-1.728,0.47 c-4.332,0.039-8.665,0.021-13.426,0.021c0-6.058-0.366-11.983,0.217-17.813c0.182-1.818,2.919-3.389,4.506-5.053 c0.257-0.27,0.892-0.432,0.896-0.653c0.1-4.62,4.53-5.932,6.822-8.85C20.001,20.139,22.547,18.013,25.503,15.048z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZ17);
export default __webpack_public_path__ + "static/media/z17.c3312c86979b7a60c1179ecb448ee18a.svg";
export { ForwardRef as ReactComponent };